"use client";
import { jsx } from "react/jsx-runtime";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { popoverVariants } from "./Popover.variants.js";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverPositioner_PopoverPositioner = /*#__PURE__*/ forwardRef(function({ className, slots, side = 'bottom', align = 'center', sideOffset = 8, children, ...props }, ref) {
    const mode = usePopoverMode();
    if ('drawer' === mode) return /*#__PURE__*/ jsx("div", {
        ref: ref,
        className: cn(className, slots?.positioner),
        children: children
    });
    const { positioner } = popoverVariants();
    return /*#__PURE__*/ jsx(Popover.Positioner, {
        ref: ref,
        side: side,
        align: align,
        sideOffset: sideOffset,
        className: cn(positioner(), className, slots?.positioner),
        ...props,
        children: children
    });
});
export { PopoverPositioner_PopoverPositioner as PopoverPositioner };
